<template>
    <div class="supplier_photos">
      <v-container fluid>
        <v-row class="ma-0">
          <v-col class="pa-0">
            <v-radio-group v-model="selected_category" row>
              <v-radio label="設備" :value="1"></v-radio>
              <v-radio label="製品/カタログ" :value="2"></v-radio>
              <v-radio label="建屋/人物" :value="3"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid v-for="catData in photoMap" :key="catData.cat" v-show="selected_category == catData.cat">
            <v-row>
                <v-col
                        v-for="img in catData.photos"
                        :key="img.fileId"
                        cols="12"
                        md="4"
                >
                    <image-view :image-id="img.fileId" width="300" height="300"></image-view>

                    <p>写真へのコメント {{img.fileId}} {{img.remarks}}</p>

                </v-col>
            </v-row>
      </v-container>
        
    </div>
</template>
<script>

import BaseView from "../../components/BaseView";

export default {
    mixins:[BaseView],
    components: {

    },
    props: {
      cat1: {
        type: Array,
        required: true
      },
      cat2: {
        type: Array,
        required: true
      },
      cat3: {
        type: Array,
        required: true
      },
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        selected_category:1,

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {
      photoMap:function (){
        return [
          {
            cat:1,
            photos:this.cat1
          },
          {
            cat:2,
            photos:this.cat2
          },
          {
            cat:3,
            photos:this.cat3
          },
        ]
      }
    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){

        },

    },

}
</script>